import { useEffect, useState } from 'react'
import { UserDTO } from '~/domain/user/dto/UserDTO'
import { LoginUserDTO } from '~/domain/user/dto/LoginUserDTO'

export interface Props {
  user: UserDTO
  loginUser?: LoginUserDTO
}

export const useSponsorRequestWidget = (props: Props) => {
  const { user, loginUser } = props
  const isSelf = loginUser?.id === user.id
  const [canSponsorRequest, setCanSponsorRequest] = useState(false)
  const onRequest = () => {
    setCanSponsorRequest(false)
  }

  useEffect(() => {
    ; (async () => {
      if (isSelf) {
        return
      }

      const response = await fetch(
        `/api/v1/users/${user.id}/sponser-requests/can`,
      )
      const json = (await response.json()) as {
        error?: string
        can: boolean
      }

      setCanSponsorRequest(json.can)
    })()
  }, [user.id, isSelf])

  return {
    user,
    loginUser,
    canSponsorRequest,
    isSelf,
    onRequest,
  }
}
